import { useContext, useEffect } from "react";
import { observer } from "mobx-react-lite";
import { SOCKET_EVENTS, SocketContext } from "./SocketProvider";
import PersonalAccount from "../store/PersonalAccount";
import Points from "../store/Points";
import useModalActions from "../hooks/useModalActions";
import { MODAL_TYPES } from "../utils/emitter";

// Мост socket-событий Этапа 2 -> глобальные модалки/сторы.
// Монтируется в RootModals (внутри SocketProvider), ничего не рендерит.
export default observer(function Etap2SocketBridge() {
  const { socket } = useContext(SocketContext);
  const { openModal } = useModalActions();

  useEffect(() => {
    const onPointsAccrued = (payload) => {
      const userId = PersonalAccount.user?.id;
      if (!userId || payload?.userId !== userId) return;
      const is500 = Number(payload?.amount) === 500;
      // +500 за прохождение теста в паре: баланс обновляем сразу, но «взрыв» в ЛК
      // НЕ заводим (silent) — анимацию «+500» показывает сам congrats-попап (Task 2),
      // а попап откладываем до нажатия «Смотреть» (/matches). +100/+200 (друг прошёл
      // тест / друг прошёл +57) — как раньше: взрыв в ЛК + попап сразу.
      Points.applyAccrual(payload.amount, payload.balance, { silent: is500 });
      if (is500) {
        Points.setPendingCongrats(payload);
      } else {
        openModal(MODAL_TYPES.POINTS_CONGRATS, payload);
      }
    };

    const onExtendedUnlocked = async (payload) => {
      const userId = PersonalAccount.user?.id;
      // попап «партнёр разблокировал 57 карточек» — только второй стороне
      if (!userId || payload?.partnerId !== userId) return;
      await PersonalAccount.getPersonalAccountData();
      openModal(MODAL_TYPES.PARTNER_UNLOCKED_57, payload);
    };

    socket.current.on(SOCKET_EVENTS.POINTS_ACCRUED, onPointsAccrued);
    socket.current.on(SOCKET_EVENTS.EXTENDED_57_UNLOCKED, onExtendedUnlocked);
    return () => {
      socket.current.off(SOCKET_EVENTS.POINTS_ACCRUED, onPointsAccrued);
      socket.current.off(SOCKET_EVENTS.EXTENDED_57_UNLOCKED, onExtendedUnlocked);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
});
